/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { EntityPermissionResponse } from "../models/entityPermissionResponse";

import type { EntityPermissionsRequest } from "../models/entityPermissionsRequest";

import type { HitsEntityPermissions } from "../models/hitsEntityPermissions";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Entity Permissions
 */
export const fetchEntityPermissions = (
  entityPermissionsRequest: EntityPermissionsRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityPermissionResponse>(
    {
      url: `/api/custom-interfaces/permissions/entity-permissions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: entityPermissionsRequest,
      signal,
    },
    options,
  );
};

export const getFetchEntityPermissionsQueryKey = (
  entityPermissionsRequest?: EntityPermissionsRequest,
) => {
  return [
    `/api/custom-interfaces/permissions/entity-permissions`,
    entityPermissionsRequest,
  ] as const;
};

export const getFetchEntityPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  entityPermissionsRequest: EntityPermissionsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFetchEntityPermissionsQueryKey(entityPermissionsRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchEntityPermissions>>
  > = ({ signal, meta }) =>
    fetchEntityPermissions(
      entityPermissionsRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchEntityPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchEntityPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchEntityPermissions>>
>;
export type FetchEntityPermissionsQueryError = ErrorType<unknown>;

export function useFetchEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  entityPermissionsRequest: EntityPermissionsRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEntityPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEntityPermissions>>,
          TError,
          Awaited<ReturnType<typeof fetchEntityPermissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  entityPermissionsRequest: EntityPermissionsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEntityPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchEntityPermissions>>,
          TError,
          Awaited<ReturnType<typeof fetchEntityPermissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  entityPermissionsRequest: EntityPermissionsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Entity Permissions
 */

export function useFetchEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  entityPermissionsRequest: EntityPermissionsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchEntityPermissionsQueryOptions(
    entityPermissionsRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Entity Permissions
 */
export const prefetchFetchEntityPermissions = async <
  TData = Awaited<ReturnType<typeof fetchEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityPermissionsRequest: EntityPermissionsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFetchEntityPermissionsQueryOptions(
    entityPermissionsRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary User Entity Permissions
 */
export const fetchUserEntityPermissions = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntityPermissions>(
    {
      url: `/api/custom-interfaces/permissions/user-entity-permissions`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getFetchUserEntityPermissionsQueryKey = () => {
  return [
    `/api/custom-interfaces/permissions/user-entity-permissions`,
  ] as const;
};

export const getFetchUserEntityPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchUserEntityPermissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchUserEntityPermissions>>
  > = ({ signal, meta }) =>
    fetchUserEntityPermissions({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchUserEntityPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchUserEntityPermissions>>
>;
export type FetchUserEntityPermissionsQueryError = ErrorType<unknown>;

export function useFetchUserEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
          TError,
          Awaited<ReturnType<typeof fetchUserEntityPermissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchUserEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
          TError,
          Awaited<ReturnType<typeof fetchUserEntityPermissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchUserEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary User Entity Permissions
 */

export function useFetchUserEntityPermissions<
  TData = Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchUserEntityPermissionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary User Entity Permissions
 */
export const prefetchFetchUserEntityPermissions = async <
  TData = Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchUserEntityPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFetchUserEntityPermissionsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
